import React from 'react'

import ImageWithText from '../../components/ImageWithText'
import screenshotUrl from './screenshot.png'

const ProfessionalNetworkScreen2: React.FC = () => (
  <ImageWithText
    imageUrl={screenshotUrl}
    text={
      <p>
        Click on a firm to view its profile. See an overview, locations,
        services, teams, internal comments and more. To refer a client, just hit
        the blue Refer button.
      </p>
    }
  />
)

export default ProfessionalNetworkScreen2
